import * as ActionType from '../constants/constant_action_types';

const INIT_STATE = {
  data: null,
  error: null,
  isLoading: false,
};

const pdfPreviewReducer = function (state = INIT_STATE, action) {
  switch (action.type) {
    case ActionType.IS_LOADING_PREVIEW: {
      return { ...state, isLoading: true };
    }

    case ActionType.IS_DONE_LOADING_PREVIEW: {
      return { ...state, isLoading: false, data: action.payload };
    }

    case ActionType.IS_ERROR_LOADING_PREVIEW: {
      return { ...state, isLoading: false, data: null, error: action.payload };
    }

    default:
      return state;
  }
};

export default pdfPreviewReducer;
